module.exports = __webpack_public_path__ + "static/media/MenuChocolates.8a9cd3d4.jpg";